const DEV_BACKEND = `http://localhost:${process.env.BACKEND_PORT || '8000'}`;
const TEST_BACKEND = 'https://tutor-api.acornx.ai';
const PROD_BACKEND = 'https://tutor-api.pengi.ai';

function stripPort(host: string): string {
  return host.replace(/:\d+$/, '').toLowerCase();
}

export function resolveBackendBaseByHostname(hostname: string): string {
  const host = stripPort(hostname);
  const isTestHost = (
    host === 'learn-test.nanci.ai'
    || host === 'learn-test.acornx.ai'
  );

  if (host === 'localhost' || host === '127.0.0.1') {
    return DEV_BACKEND;
  }

  if (isTestHost) {
    return TEST_BACKEND;
  }

  if (host === 'pengi.ai' || host === 'tutor.pengi.ai') {
    return PROD_BACKEND;
  }

  return PROD_BACKEND;
}

export function getClientBackendBaseUrl(): string {
  if (typeof window === 'undefined') {
    return PROD_BACKEND;
  }
  return resolveBackendBaseByHostname(window.location.hostname);
}

export function getServerBackendBaseUrl(request: {
  headers: { get(name: string): string | null };
  nextUrl?: { hostname?: string };
}): string {
  const hostHeader = request.headers.get('x-forwarded-host') || request.headers.get('host') || '';
  const primaryHost = hostHeader.split(',')[0]?.trim();
  const hostname = primaryHost || request.nextUrl?.hostname || '';
  return resolveBackendBaseByHostname(hostname);
}
